import React, { FC, useState, useEffect } from 'react'
import Checkbox from '../../UI/Inputs/Checkbox'
import PostActionWrapper, { MARK_TYPE } from '../PostActionWrapper/index'
import PostActionTitle from '../PostActionTitle/index'
import PostActionQuestionAnswerForm from '../PostActionQuestionAnswerForm'
import { Can } from '../../../CASL/Can'

import './PostActionBody.scss'
import { QUESTION_ANSWER_FORM_TYPE, TApproveCheckbox } from '../../../store/managePost/newTypes'
import { ACTION_TYPE, TApprovalAction } from '../../../models/post'
import Lightbox from 'react-image-lightbox'
import TrashRed from '../../../assets/img/trash-red.svg'
import TrashIcon from '../../UI/Icons/Trash'
import AttachmentIcon from '../../../assets/img/attachment-black.svg'
import { reviseNotesThunk, showAllPostSocialNoteThunk } from '../../../store/managePost/thunks'
import { useDispatch } from '../../../store'
import { AnySchema } from 'yup'
import _ from 'lodash'
import { isFulfilled, isRejected } from '@reduxjs/toolkit'
import { TOAST_MESSAGE } from '../../UI/ToastNotification/ToastNotification'
import { useToasts } from 'react-toast-notifications'

interface PostActionBodyProps {
  message: string
  checkboxes?: TApproveCheckbox[]
  approvalId: number
  questionAnswerHistory: TApprovalAction[]
  isEditableMode: boolean
  setIsEditableMode: Function
  attachments?: Array<any>
  checkBoxOnChangeStatus?: (status: boolean, checkboxId: number) => void
  actionId: number
  deleteImage: Function
  selectedPostSocialId: number
}
interface inputChangePropType {
  value?: string
  index?: number
  checked?: any
}
interface checkboxLabel {
  any: string
}

const PostActionBody: FC<PostActionBodyProps> = ({
  message,
  questionAnswerHistory,
  checkboxes,
  approvalId,
  attachments,
  checkBoxOnChangeStatus,
  isEditableMode,
  setIsEditableMode,
  actionId,
  deleteImage,
  selectedPostSocialId
}) => {
  const [showAttachImage, setShowAttachImage] = useState<string>('')
  const [isEditget, setisEditget] = useState<boolean>(false)
  const [checkboxLabel, setCheckboxLabel] = useState<any>({})
  const [inputChangeObject, setinputChangeObject] = useState<inputChangePropType>({})
  const [attachmentToBeUploaded, setAttachmentToBeUploaded] = useState<Array<any>>([])
  const [attachmentClone, setAttachmentClone] = useState<Array<any>>(attachments ? attachments : [])
  const [checkboxClone, setCheckboxClone] = useState(_.cloneDeep(checkboxes))
  const [newInputData, setnewInputData] = useState({ checkboxStatus: false, checkboxLabel: '' })
  const [messageClone, setmessageClone] = useState(message)
  const [isInitialSave, setIsInitialSave] = useState(true)

  const { addToast } = useToasts()

  useEffect(() => {
    checkboxLabelCreator()
  }, [checkboxes, message, attachments, checkboxClone])

  const acceptedAttachment = 'image/*'
  const dispatch = useDispatch()

  const checkboxLabelCreator = () => {
    let dummyCheckBoxLabel = {}
    checkboxClone?.map(({ label, id }) => {
      dummyCheckBoxLabel = { ...dummyCheckBoxLabel, [`${id}`]: label }
    })
    setCheckboxLabel({ ...dummyCheckBoxLabel })
  }
  const viewAttachment = (image: string): void => {
    setShowAttachImage(image)
  }

  const onCloseAttachment = (): void => {
    setShowAttachImage('')
  }
  const attachFiles = (event: any) => {
    const {
      target: { files }
    } = event
    const attachmentFiles = [...attachmentToBeUploaded]
    if (files && files.length > 0) {
      for (let i = 0; i < files.length; i++) {
        attachmentFiles.push(files[i])
      }
    }
    setAttachmentToBeUploaded(attachmentFiles)
  }
  const saveLabelData = async () => {
    const data = new FormData()
    data.append('approval_action_id', actionId.toString())
    data.append('approval_id', approvalId.toString())
    checkboxes &&
      Object.entries(checkboxLabel).map(([objectKey, objectValue], objectIndex) => {
        data.append(`checkboxes[${objectIndex}][label]`, String(objectValue))
        data.append(
          `checkboxes[${objectIndex}][is_checked]`,
          String(Boolean(checkboxes[objectIndex]?.is_checked || false))
        )
      })
    if (!_.isEmpty(newInputData.checkboxLabel)) {
      data.append(
        `checkboxes[${Object.keys(checkboxLabel).length}][label]`,
        String(newInputData.checkboxLabel)
      )

      data.append(
        `checkboxes[${Object.keys(checkboxLabel).length}][is_checked]`,
        String(Boolean(newInputData.checkboxStatus))
      )
    }

    if (attachmentToBeUploaded && attachmentToBeUploaded.length > 0) {
      attachmentToBeUploaded.forEach((v: string | Blob) => {
        data.append('attachments[]', v)
      })
    }
    data.append(`message`, messageClone)

    const responseData = await dispatch(reviseNotesThunk(data))
    if (isFulfilled(responseData)) {
      const { checkboxes, attachments, message } = responseData.payload.data
      setmessageClone(message);
      setAttachmentClone(attachments);
      setCheckboxClone(checkboxes)
      setAttachmentToBeUploaded([])
      setnewInputData({ checkboxStatus: false, checkboxLabel: '' })
    }
  }

  useEffect(() => {
    if (!isEditableMode) {
      !isInitialSave && saveLabelData()
      setIsInitialSave(false)
    } else {
      setinputChangeObject({})
    }
  }, [isEditableMode])

  const changeLabel = (e: any, id: string | number, index: number, checked: boolean) => {
    setCheckboxLabel({ ...checkboxLabel, [`${id}`]: e.target.value })
    setinputChangeObject({ [`${index}`]: { value: e.target.value, id, checked } })
  }

  const deleteImageAndManipulateAttachment = (e: any, v: any, index: any) => {
    e.stopPropagation()
    deleteImage(v) &&
      setAttachmentClone((attachmentClone) => {
        const dummyAttachmentClone = [...attachmentClone]
        dummyAttachmentClone.splice(index, 1)
        return dummyAttachmentClone
      })
  }
  const deleteAttachment = (index: number) => {
    const attachmentFiles = [...attachmentToBeUploaded]
    attachmentFiles.splice(index, 1)
    setAttachmentToBeUploaded(attachmentFiles)
  }

  const deleteCheckoxLabel = (checkboxId: number, checkboxIndex: number) => {
    setCheckboxClone((deepCheckboxClone) => {
      deepCheckboxClone?.splice(checkboxIndex, 1)
      return deepCheckboxClone
    })
    let dummyCheckboxLabel = _.cloneDeep(checkboxLabel)
    delete dummyCheckboxLabel[checkboxId]
    setCheckboxLabel({ ...dummyCheckboxLabel })
  }

  return (
    <div className='post-action_content-body-container'>
      <div className='post-action_content-body'>
        {questionAnswerHistory.length ? (
          <div className='post-action_left-border-body'></div>
        ) : (
          <></>
        )}
        {checkboxes && !!checkboxes.length && checkBoxOnChangeStatus && (
          <>
            <div className='post-action_content-body-title'>Checklist</div>
            {checkboxClone?.map(({ is_checked: checked, id }, index) => (
              <div key={id} className='post-action_content-body-checklist-container'>
                <Checkbox
                  checked={checked}
                  onChange={({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) =>
                    checkBoxOnChangeStatus(checked, id)
                  }
                />
                {isEditableMode ? (
                  <>
                    <input
                      className='post-action_container-input'
                      value={checkboxLabel[`${id}`]}
                      maxLength={255}
                      onChange={(e) => changeLabel(e, id, index, checked)}
                    />
                    <img
                      className='post-input-container_delete'
                      placeholder='Type here'
                      src={TrashRed}
                      alt=''
                      onClick={() => {
                        deleteCheckoxLabel(id, index)
                      }}
                    />
                  </>
                ) : (
                  <div className='post-action_container-field'>{checkboxLabel[`${id}`]}</div>
                )}
              </div>
            ))}
            {isEditableMode ? (
              <>
                <div className='post-action_content-body-checklist-container'>
                  <Checkbox
                    checked={newInputData.checkboxStatus}
                    onChange={({ target: { checked } }: React.ChangeEvent<HTMLInputElement>) =>
                      setnewInputData({ ...newInputData, checkboxStatus: checked })
                    }
                  />
                  <input
                    className='post-action_container-input'
                    value={newInputData.checkboxLabel}
                    maxLength={255}
                    placeholder={'Type here...'}
                    onChange={(e) =>
                      setnewInputData({ ...newInputData, checkboxLabel: e.target.value })
                    }
                  />
                </div>
              </>
            ) : (
              <></>
            )}
          </>
        )}

        {message && (
          <>
            <div className='post-action_content-body-title mt-15'>
              Notes{' '}
              {isEditableMode && <label>
                <img className='attachment' src={AttachmentIcon} />
                <input
                  id='attachment-upload'
                  style={{ display: 'none' }}
                  type='file'
                  multiple
                  accept={acceptedAttachment}
                  onChange={($event) => attachFiles($event)}
                />
              </label>}
            </div>

            {isEditableMode ? (
              <input
                className='post-action_container-input'
                value={messageClone}
                maxLength={1000}
                onChange={(e) => setmessageClone(e.target.value)}
              />
            ) : (
              <div className='post-action_content-body-checklist-note'>{messageClone}</div>
            )}
            <div className='post-action-notes-box'>
              {attachmentClone && attachmentClone.length > 0 ? (
                <div className='thumbnail'>
                  <ul>
                    {attachmentClone.map((v, index) => (
                      <li className='image-actions'>
                        <img
                          src={v.object_data.public_url}
                          onClick={() => viewAttachment(v.object_data.public_url)}
                        />
                        {isEditableMode && (
                          <div
                            className='image-actions_remove post-image-actions-remove'
                            onClick={(e) => {
                              deleteImageAndManipulateAttachment(e, v, index)
                            }}
                          >
                            <TrashIcon />
                          </div>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ) : null}
              {showAttachImage ? (
                <Lightbox mainSrc={showAttachImage} onCloseRequest={onCloseAttachment} />
              ) : null}
            </div>
          </>
        )}

        {attachmentToBeUploaded && attachmentToBeUploaded.length > 0 ? (
          <div className='thumbnail'>
            <ul>
              {attachmentToBeUploaded.map((v, k) => (
                <li className='image-actions'>
                  <div className='image-actions_remove post-image-actions-remove' onClick={() => deleteAttachment(k)}>
                    <TrashIcon />
                  </div>
                  <img
                    className='img'
                    src={URL.createObjectURL(v)}
                    onClick={() => viewAttachment(URL.createObjectURL(v))}
                  />
                </li>
              ))}
            </ul>
          </div>
        ) : null}
        <Can I='makeRevisionQuestion' a='Post'>
          <PostActionQuestionAnswerForm
            approvalId={approvalId}
            formType={QUESTION_ANSWER_FORM_TYPE.TYPE_QUESTION}
          />
        </Can>
      </div>
      {!!questionAnswerHistory.length && (
        <div className='question-answer-history_container'>
          {questionAnswerHistory.map(
            (
              {
                message,
                type,
                id: actionId,
                approval_id: approvalId,
                created_at: createdAt,
                created_by_user: { name, avatar_image_link }
              },
              index
            ) => (
              <div key={actionId}>
                <PostActionWrapper
                  actionType={type}
                  bottomLine={questionAnswerHistory.length - 1 !== index}
                  typeOfMark={MARK_TYPE.TYPE_MARK}
                  datetime={createdAt}
                >
                  <PostActionTitle
                    from={name}
                    type={type}
                    avatar={avatar_image_link}
                    shouldEnableEdit
                    isEditableMode={isEditableMode}
                    setIsEditableMode={setIsEditableMode}
                  />
                  <div className='post-action_content-body'>
                    <div className='post-action_content-body-checklist-note'>{message}</div>
                    {type === ACTION_TYPE.TYPE_QUESTION_PUSHED && (
                      <Can I='makeRevisionResponse' a='Post'>
                        <PostActionQuestionAnswerForm
                          approvalId={approvalId}
                          formType={QUESTION_ANSWER_FORM_TYPE.TYPE_ANSWER}
                        />
                      </Can>
                    )}
                  </div>
                </PostActionWrapper>
              </div>
            )
          )}
        </div>
      )}
    </div>
  )
}

export default PostActionBody
